import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IGoodInventoryReasonListResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setReasonList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useReasonListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(INVENTORY_MODULE?.REASON_LIST?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IGoodInventoryReasonListResponse>) => {
          if (res.data.status === true) {
            dispatch(setReasonList({ data: res.data.data }));
          } else {
            dispatch(setReasonList({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e)
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
